import { useEffect } from 'react';
import styled from '@emotion/styled';
import CircularLoader from '@base/CircularLoader/CircularLoader';
import { emptyList } from '@constants/empty';
import { Spacings } from '@styles/index';
import useIntersection from '@hooks/useIntersection';
import useMounted from '@hooks/useMounted';

const IntersectingSection = styled.div`
  height: ${Spacings.SPACING_3B};
  width: 100%;
`;

const Loader = () => <CircularLoader />;

const InfiniteFeedRow = ({
  data = emptyList,
  isLoading = true,
  renderLoader = Loader,
  onLoadMore,
  renderItem
}) => {
  const { intersecting, ref } = useIntersection();
  const mounted = useMounted();

  useEffect(() => {
    if (intersecting && !isLoading) {
      onLoadMore();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [intersecting, isLoading]);

  const renderItems = () => data.map((item, index) => renderItem(item, index));

  return (
    <>
      {renderItems()}
      <>
        {mounted && <IntersectingSection ref={ref} />}
        {isLoading && renderLoader()}
      </>
    </>
  );
};

export default InfiniteFeedRow;
